import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../services/dashboard-api';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => dashboardApi.stats(),
    refetchInterval: 60000,
  });
}

export function useRevenueChart(months = 6) {
  return useQuery({
    queryKey: ['dashboard', 'revenue-chart', months],
    queryFn: () => dashboardApi.revenueChart(months),
  });
}

export function useRecentInvoices() {
  return useQuery({
    queryKey: ['dashboard', 'recent-invoices'],
    queryFn: () => dashboardApi.recentInvoices(),
    refetchInterval: 30000,
  });
}

export function useOverdueInvoices() {
  return useQuery({
    queryKey: ['dashboard', 'overdue-invoices'],
    queryFn: () => dashboardApi.overdueInvoices(),
  });
}

export function useOnboardingStatus() {
  return useQuery({
    queryKey: ['dashboard', 'onboarding-status'],
    queryFn: () => dashboardApi.onboardingStatus(),
  });
}

export function useOverdueTrend() {
  return useQuery({
    queryKey: ['dashboard', 'overdue-trend'],
    queryFn: () => dashboardApi.overdueTrend(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCollectionRate() {
  return useQuery({
    queryKey: ['dashboard', 'collection-rate'],
    queryFn: () => dashboardApi.collectionRate(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useVatSummary() {
  return useQuery({
    queryKey: ['dashboard', 'vat-summary'],
    queryFn: () => dashboardApi.vatSummary(),
    staleTime: 5 * 60 * 1000,
  });
}
